import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { HiMenu } from "react-icons/hi";
import routesdata from "../../routes/routesdata";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { useSelector } from "react-redux";
import { CLIENT_VENDOR } from "../../constants/roles";

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const location = useLocation();
  const user = useSelector((state) => state?.auth?.user);

  useEffect(() => {
    const checkScreen = () => {
      setIsSmallScreen(window.innerWidth <= 1280); // xl breakpoint
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const toggleSidebar = () => setIsOpen((prev) => !prev);
  const closeSidebar = () => isSmallScreen && setIsOpen(false);

  return (
    <>
      {/* Mobile Menu Button */}
      {isSmallScreen && (
        <button
          onClick={toggleSidebar}
          className="fixed top-5 left-3 z-[60] text-primary p-2 rounded-md bg-white shadow xl:hidden"
        >
          <HiMenu className="w-5 h-5" />
        </button>
      )}

      {/* Backdrop (click anywhere to close) */}
      {isSmallScreen && isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40 xl:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        onClick={(e) => e.stopPropagation()}
        className={`fixed xl:static bg-gradient-to-b from-teal-50 to-orange-50
        top-0 left-0 z-50 xl:z-0
        w-40 xl:w-44 h-full transform border-r border-zinc-300 shadow-lg
        transition-transform duration-300 ease-in-out
        ${
          isSmallScreen
            ? isOpen
              ? "translate-x-0"
              : "-translate-x-full"
            : "translate-x-0"
        }`}
      >
        {/* Close Icon (mobile only) */}
        <IoIosArrowDropleftCircle
          onClick={closeSidebar}
          className={`fixed top-5 -right-2 text-xl text-primary xl:hidden
          ${isSmallScreen && isOpen ? "block" : "hidden"}`}
        />

        {/* Logo / Title */}
        <h1 className="pt-3 pb-2 font-extrabold tracking-wider
        text-base md:text-xl xl:text-3xl text-center text-primary">
          MRR
        </h1>

        <div className="m-2">
          {/* Profile */}
          <div className="flex flex-col items-center py-3 border-b border-gray-500 px-4">
            <div className="bg-white rounded-full w-12 h-12 md:w-16 md:h-16 xl:w-[70px] xl:h-[70px] mb-2">
              <img
                src={user?.profile}
                alt="Profile"
                className="rounded-full h-full w-full object-cover"
              />
            </div>

            <h2 className="text-lg font-semibold text-primary capitalize pb-1 text-center">
              {user?.name}
            </h2>

            <h2 className="text-[15px] font-semibold text-primary capitalize pb-2 text-center">
              [
              {user?.role === CLIENT_VENDOR
                ? "Technical Consultant"
                : user?.role?.split("_").join(" ").toLowerCase()}
              ]
            </h2>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto px-1 py-3 xl:px-3 space-y-1 xl:space-y-2">
            {routesdata
              .filter((item) => item.role.includes(user?.role))
              .map((item, idx) => {
                const isActive = location.pathname === item.path;

                return (
                  <Link
                    key={idx}
                    to={item.path}
                    onClick={() => {
                      sessionStorage.setItem("header", item.title);
                      closeSidebar();
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-2 rounded-lg
                    transition-all duration-200 group
                    ${
                      isActive
                        ? "bg-blue-50 text-blue-600 font-semibold shadow-inner"
                        : "text-zinc-700 hover:bg-gray-100 hover:shadow"
                    }`}
                  >
                    <span
                      className={`text-lg transition-transform duration-200 group-hover:scale-110
                      ${isActive ? "text-blue-600" : "text-primary"}`}
                    >
                      {item.icon}
                    </span>
                    <span className="text-base font-medium">
                      {item.title}
                    </span>
                  </Link>
                );
              })}
          </nav>
        </div>
      </aside>
    </>
  );
}
